import { Box, styled } from '@mui/system';
import { PayrollTabContainer } from '../styles';

export const WageExemptionsContainer = styled(PayrollTabContainer)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const UPDataGridContainer = styled(Box)(() => ({
  height: '300px',
  width: '100%',
}));
